export default __webpack_public_path__ + "static/media/colgante-medialuna.f592eff4.png";